import { EventEmitter, Component, Input, Output, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { _log, B2CSharedPipeModule } from 'b2c-ui/core';
import { NzFormModule } from 'ng-zorro-antd/form';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { I18nTransKey, I18nModule } from 'b2c-ui/i18n';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { CommonModule } from '@angular/common';
import { B2CProductBarModule } from 'b2c-ui/product-bar';
import { B2CNgzIconModule } from 'b2c-ui/ngz-icons';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-menu-drawer.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from 'ng-zorro-antd/drawer';
import * as ɵngcc3 from 'ng-zorro-antd/grid';
import * as ɵngcc4 from 'ng-zorro-antd';
import * as ɵngcc5 from '@angular/forms';
import * as ɵngcc6 from 'ng-zorro-antd/input';
import * as ɵngcc7 from 'ng-zorro-antd/checkbox';
import * as ɵngcc8 from 'ng-zorro-antd/radio';
import * as ɵngcc9 from 'b2c-ui/product-bar';
import * as ɵngcc10 from 'b2c-ui/i18n';
import * as ɵngcc11 from 'b2c-ui/core';
import * as ɵngcc12 from 'ng-zorro-antd/card';
import * as ɵngcc13 from 'ng-zorro-antd/button';

function B2CMenuDrawerComponent_nz_drawer_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "nz-drawer", 2);
    ɵngcc0.ɵɵlistener("nzOnClose", function B2CMenuDrawerComponent_nz_drawer_0_Template_nz_drawer_nzOnClose_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.close(); });
    ɵngcc0.ɵɵelement(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "b2c-selection-half", 5);
    ɵngcc0.ɵɵlistener("filter", function B2CMenuDrawerComponent_nz_drawer_0_Template_b2c_selection_half_filter_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.filterOption($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("nzClosable", false)("nzVisible", ctx_r0.show);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("radioValue", ctx_r0.radioValue)("title", ctx_r0.title)("type", ctx_r0.type)("itemList", ctx_r0.itemList);
} }
function B2CMenuDrawerComponent_b2c_selection_full_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "b2c-selection-full", 6);
    ɵngcc0.ɵɵlistener("filter", function B2CMenuDrawerComponent_b2c_selection_full_1_Template_b2c_selection_full_filter_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.filterOption($event); })("closed", function B2CMenuDrawerComponent_b2c_selection_full_1_Template_b2c_selection_full_closed_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.close(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("radioValue", ctx_r1.radioValue)("selections", ctx_r1.itemList)("visible", ctx_r1.show)("type", ctx_r1.type)("title", ctx_r1.title)("showAllSelectionCheckbox", ctx_r1.showAllSelection);
} }
function B2CSelectionFullComponent_a_10_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 19);
    ɵngcc0.ɵɵlistener("click", function B2CSelectionFullComponent_a_10_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.clear(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r0.I18nTransKey == null ? null : ctx_r0.I18nTransKey.CLEAR));
} }
function B2CSelectionFullComponent_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 20);
} }
function B2CSelectionFullComponent_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 21);
    ɵngcc0.ɵɵlistener("click", function B2CSelectionFullComponent_ng_template_17_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.clearInput(); });
    ɵngcc0.ɵɵelementEnd();
} }
function B2CSelectionFullComponent_ng_container_20_label_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "label", 24);
    ɵngcc0.ɵɵelementStart(1, "span", 25);
    ɵngcc0.ɵɵtext(2, "ALL");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "label", 26);
    ɵngcc0.ɵɵlistener("ngModelChange", function B2CSelectionFullComponent_ng_container_20_label_1_Template_label_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.onCheckAll($event); })("ngModelChange", function B2CSelectionFullComponent_ng_container_20_label_1_Template_label_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.checkAll = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r12.checkAll);
} }
function B2CSelectionFullComponent_ng_container_20_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵelementStart(2, "div", 27);
    ɵngcc0.ɵɵelementStart(3, "span", 28);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "label", 26);
    ɵngcc0.ɵɵlistener("ngModelChange", function B2CSelectionFullComponent_ng_container_20_ng_container_2_Template_label_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const item_r17 = ctx.$implicit; return item_r17.checked = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r17 = ctx.$implicit;
    const i_r18 = ctx.index;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("b2c-selection-full-checkbox option-", i_r18 + 1, " m-0 w-100");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(item_r17.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", item_r17.checked);
} }
function B2CSelectionFullComponent_ng_container_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CSelectionFullComponent_ng_container_20_label_1_Template, 4, 1, "label", 22);
    ɵngcc0.ɵɵtemplate(2, B2CSelectionFullComponent_ng_container_20_ng_container_2_Template, 6, 5, "ng-container", 23);
    ɵngcc0.ɵɵpipe(3, "filter");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.showAllSelectionCheckbox);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(3, 2, ctx_r5.selections, ctx_r5.searchText));
} }
function B2CSelectionFullComponent_ng_container_21_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "label", 30);
    ɵngcc0.ɵɵelementStart(2, "div", 27);
    ɵngcc0.ɵɵelementStart(3, "span", 31);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "label", 32);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r22 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(item_r22.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzValue", item_r22.value);
} }
function B2CSelectionFullComponent_ng_container_21_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "nz-radio-group", 29);
    ɵngcc0.ɵɵlistener("ngModelChange", function B2CSelectionFullComponent_ng_container_21_Template_nz_radio_group_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.onModelChange($event); })("ngModelChange", function B2CSelectionFullComponent_ng_container_21_Template_nz_radio_group_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.radioValue = $event; });
    ɵngcc0.ɵɵtemplate(2, B2CSelectionFullComponent_ng_container_21_ng_container_2_Template, 6, 2, "ng-container", 23);
    ɵngcc0.ɵɵpipe(3, "filter");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.radioValue);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(3, 2, ctx_r6.selections, ctx_r6.searchText));
} }
function B2CSelectionFullComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 33);
    ɵngcc0.ɵɵelementStart(1, "b2c-product-bar-filter", 34);
    ɵngcc0.ɵɵlistener("click", function B2CSelectionFullComponent_div_22_Template_b2c_product_bar_filter_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.filterItem(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("oneButton", "true");
} }
const _c0 = function () { return { height: "100%", overflow: "hidden" }; };
function B2CSelectionHalfComponent_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 6);
    ɵngcc0.ɵɵlistener("click", function B2CSelectionHalfComponent_a_4_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.clear(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r0.I18nTransKey == null ? null : ctx_r0.I18nTransKey.CLEAR));
} }
function B2CSelectionHalfComponent_ng_container_5_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "label", 7);
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "label", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function B2CSelectionHalfComponent_ng_container_5_ng_container_5_Template_label_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const item_r7 = ctx.$implicit; return item_r7.checked = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(item_r7.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", item_r7.checked);
} }
function B2CSelectionHalfComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "label", 7);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3, "ALL");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "label", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function B2CSelectionHalfComponent_ng_container_5_Template_label_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onCheckAll($event); })("ngModelChange", function B2CSelectionHalfComponent_ng_container_5_Template_label_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.checkAll = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, B2CSelectionHalfComponent_ng_container_5_ng_container_5_Template, 6, 2, "ng-container", 9);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.checkAll);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.itemList);
} }
function B2CSelectionHalfComponent_ng_container_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "label", 7);
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "label", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r14 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(item_r14.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzValue", item_r14.value);
} }
function B2CSelectionHalfComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "nz-radio-group", 11);
    ɵngcc0.ɵɵlistener("ngModelChange", function B2CSelectionHalfComponent_ng_container_6_Template_nz_radio_group_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onModelChange($event); })("ngModelChange", function B2CSelectionHalfComponent_ng_container_6_Template_nz_radio_group_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.radioValue = $event; });
    ɵngcc0.ɵɵtemplate(2, B2CSelectionHalfComponent_ng_container_6_ng_container_2_Template, 6, 2, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.radioValue);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.itemList);
} }
function B2CSelectionHalfComponent_nz_card_7_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "nz-card", 13);
    ɵngcc0.ɵɵelementStart(1, "button", 14);
    ɵngcc0.ɵɵlistener("click", function B2CSelectionHalfComponent_nz_card_7_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.filterItem(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "b2cI18n");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, ctx_r3.I18nTransKey == null ? null : ctx_r3.I18nTransKey.FILTER));
} }
function SelectionsModel() { }
if (false) {
    /** @type {?} */
    SelectionsModel.prototype.label;
    /** @type {?} */
    SelectionsModel.prototype.value;
    /** @type {?|undefined} */
    SelectionsModel.prototype.checked;
}
/**
 * ##### Import this component individually to your module
 * `import { B2CMenuDrawerModule } from 'b2c-ui/menu-drawer';`
 */
class B2CMenuDrawerComponent {
    constructor() {
        /**
         * Set Item Options
         */
        this.itemList = [];
        this.showAllSelection = true;
        /**
         * Filter Event
         */
        this.filter = new EventEmitter();
        /**
         * View Change Event
         */
        this.viewChange = new EventEmitter();
    }
    /**
     * @param {?} value
     * @return {?}
     */
    filterOption(value) {
        this.filter.emit(value);
        _log('selected Value', value);
        this.close();
    }
    /**
     * @return {?}
     */
    close() {
        this.show = false;
        this.viewChange.emit(this.show);
    }
}
B2CMenuDrawerComponent.ɵfac = function B2CMenuDrawerComponent_Factory(t) { return new (t || B2CMenuDrawerComponent)(); };
B2CMenuDrawerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CMenuDrawerComponent, selectors: [["b2c-menu-drawer"]], inputs: { itemList: "itemList", showAllSelection: "showAllSelection", show: "show", radioValue: "radioValue", title: "title", type: "type" }, outputs: { filter: "filter", viewChange: "viewChange" }, decls: 2, vars: 2, consts: [["nzPlacement", "bottom", "nzWrapClassName", "b2c-menu-drawer", 3, "nzClosable", "nzVisible", "nzOnClose", 4, "ngIf"], [3, "radioValue", "selections", "visible", "type", "title", "showAllSelectionCheckbox", "filter", "closed", 4, "ngIf"], ["nzPlacement", "bottom", "nzWrapClassName", "b2c-menu-drawer", 3, "nzClosable", "nzVisible", "nzOnClose"], [1, "position-absolute", "rounded", "b2c-menu-drawer-bar"], [1, "selection-half-container", "pt-3", "px-2"], [3, "radioValue", "title", "type", "itemList", "filter"], [3, "radioValue", "selections", "visible", "type", "title", "showAllSelectionCheckbox", "filter", "closed"]], template: function B2CMenuDrawerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, B2CMenuDrawerComponent_nz_drawer_0_Template, 4, 6, "nz-drawer", 0);
        ɵngcc0.ɵɵtemplate(1, B2CMenuDrawerComponent_b2c_selection_full_1_Template, 1, 6, "b2c-selection-full", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.itemList.length <= 6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.itemList.length > 6);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc2.NzDrawerComponent, B2CSelectionHalfComponent,
        B2CSelectionFullComponent]; }, encapsulation: 2 });
/** @nocollapse */
B2CMenuDrawerComponent.ctorParameters = () => [];
B2CMenuDrawerComponent.propDecorators = {
    show: [{ type: Input }],
    itemList: [{ type: Input }],
    radioValue: [{ type: Input }],
    title: [{ type: Input }],
    type: [{ type: Input }],
    showAllSelection: [{ type: Input }],
    filter: [{ type: Output }],
    viewChange: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CMenuDrawerComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-menu-drawer',
                template: "<nz-drawer\r\n*ngIf=\"itemList.length <= 6\"\r\n[nzClosable]=\"false\"\r\nnzPlacement=\"bottom\"\r\n[nzVisible]=\"show\"\r\nnzWrapClassName=\"b2c-menu-drawer\"\r\n(nzOnClose)=\"close()\"\r\n>\r\n  <div class=\"position-absolute rounded b2c-menu-drawer-bar\"></div>\r\n\r\n  <div class=\"selection-half-container pt-3 px-2\">\r\n    <b2c-selection-half\r\n    [radioValue]=\"radioValue\"\r\n    [title]=\"title\"\r\n    [type]=\"type\"\r\n    [itemList]=\"itemList\"\r\n    (filter)=\"filterOption($event)\"\r\n    >\r\n    </b2c-selection-half>\r\n  </div>\r\n\r\n</nz-drawer>\r\n\r\n<b2c-selection-full *ngIf=\"itemList.length > 6\"\r\n  [radioValue]=\"radioValue\"\r\n  [selections]=\"itemList\"\r\n  [visible]=\"show\"\r\n  [type]=\"type\"\r\n  [title]=\"title\"\r\n  (filter)=\"filterOption($event)\"\r\n  (closed)=\"close()\"\r\n  [showAllSelectionCheckbox]=\"showAllSelection\">\r\n</b2c-selection-full>\r\n\r\n\r\n"
            }]
    }], function () { return []; }, { itemList: [{
            type: Input
        }], showAllSelection: [{
            type: Input
        }], filter: [{
            type: Output
        }], viewChange: [{
            type: Output
        }], show: [{
            type: Input
        }], radioValue: [{
            type: Input
        }], title: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();
if (false) {
    /**
     * Set Visibility
     * @type {?}
     */
    B2CMenuDrawerComponent.prototype.show;
    /**
     * Set Item Options
     * @type {?}
     */
    B2CMenuDrawerComponent.prototype.itemList;
    /**
     * Set default radio value when type = 'radio'
     * @type {?}
     */
    B2CMenuDrawerComponent.prototype.radioValue;
    /**
     * Set Title
     * @type {?}
     */
    B2CMenuDrawerComponent.prototype.title;
    /**
     * Set Type default/radio
     * @type {?}
     */
    B2CMenuDrawerComponent.prototype.type;
    /** @type {?} */
    B2CMenuDrawerComponent.prototype.showAllSelection;
    /**
     * Filter Event
     * @type {?}
     */
    B2CMenuDrawerComponent.prototype.filter;
    /**
     * View Change Event
     * @type {?}
     */
    B2CMenuDrawerComponent.prototype.viewChange;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-selection-full.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * ##### Import this component individually to your module
 * `import { B2CSelectionFullModule } from 'b2c-ui/selection-full';`
 */
class B2CSelectionFullComponent {
    constructor() {
        this._visible = false;
        this.I18nTransKey = I18nTransKey;
        this.checkAll = false;
        /**
         * Set Selections Data
         */
        this.selections = [];
        /**
         * Filter Event
         */
        this.filter = new EventEmitter();
        /**
         * Closed Event
         */
        this.closed = new EventEmitter();
    }
    /**
     * Set Visible
     * @param {?} value
     * @return {?}
     */
    set visible(value) {
        this._visible = coerceBooleanProperty(value);
    }
    /**
     * @ignore
     * @return {?}
     */
    get visible() {
        return this._visible;
    }
    /**
     * @ignore
     * @return {?}
     */
    close() {
        this.visible = false;
        this.closed.emit(this.visible);
    }
    /**
     * @ignore
     * @return {?}
     */
    clear() {
        this.selections.forEach((/**
         * @param {?} item
         * @return {?}
         */
        item => (item.checked = false)));
    }
    /**
     * @ignore
     * @return {?}
     */
    clearInput() {
        this.searchText = '';
    }
    /**
     * @ignore
     * @return {?}
     */
    ngOnInit() {
        this.form = new FormGroup({
            search: new FormControl('', Validators.required)
        });
        this.subscription = this.form
            .get('search')
            .valueChanges.pipe(debounceTime(1000), distinctUntilChanged())
            .subscribe((/**
         * @param {?} value
         * @return {?}
         */
        (value) => {
            this.searchText = value;
            _log(this.searchText);
        }));
    }
    /**
     * @ignore
     * @return {?}
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    /**
     * @ignore
     * @return {?}
     */
    filterItem() {
        if (this.type === 'radio') {
            this.filter.emit(this.radioValue);
            this.close();
        }
        else {
            /** @type {?} */
            const selectedFilters = [];
            this.selections.forEach((/**
             * @param {?} item
             * @return {?}
             */
            item => {
                if (item.checked) {
                    selectedFilters.push(item.value);
                }
            }));
            this.filter.emit(selectedFilters);
            this.clearInput();
            _log(selectedFilters);
            this.close();
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    onModelChange(value) {
        this.radioValue = value;
        _log('full', this.radioValue);
        this.filterItem();
    }
    /**
     * @param {?} check
     * @return {?}
     */
    onCheckAll(check) {
        this.checkAll = check;
        if (this.checkAll) {
            this.selections.forEach((/**
             * @param {?} selection
             * @return {?}
             */
            (selection) => {
                selection.checked = true;
            }));
        }
        else {
            this.selections.forEach((/**
             * @param {?} selection
             * @return {?}
             */
            (selection) => {
                selection.checked = false;
            }));
        }
    }
}
B2CSelectionFullComponent.ɵfac = function B2CSelectionFullComponent_Factory(t) { return new (t || B2CSelectionFullComponent)(); };
B2CSelectionFullComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CSelectionFullComponent, selectors: [["b2c-selection-full"]], inputs: { selections: "selections", visible: "visible", radioValue: "radioValue", type: "type", title: "title", showAllSelectionCheckbox: "showAllSelectionCheckbox" }, outputs: { filter: "filter", closed: "closed" }, decls: 23, vars: 13, consts: [["nzPlacement", "left", "nzWidth", "100%", "nzWrapClassName", "b2c-selection-full-wrapper", 3, "nzClosable", "nzVisible", "nzBodyStyle", "nzOnClose"], [1, "b2c-selection-full-container", "h-100", "w-100", "d-flex", "flex-column"], [1, "b2c-selection-full-header"], [1, "border-bottom"], ["nz-row", "", "nzJustify", "center", 1, "py-2"], ["nz-col", "", "nzSpan", "5"], ["nz-icon", "", "nzType", "close", "nzTheme", "outline", 1, "b2c-selection-full-close", 3, "click"], ["nz-col", "", "nzSpan", "14", 1, "drawer-title", "font-weight-bold", "text-center"], ["nz-col", "", "nzSpan", "5", 1, "text-right"], ["class", "clear-button text-link", 3, "click", 4, "ngIf"], [1, "search-box"], [3, "formGroup"], [3, "nzPrefix", "nzSuffix"], ["type", "text", "nz-input", "", "placeholder", "Search", "formControlName", "search", 1, "search-input", 3, "ngModel", "ngModelChange"], ["prefixIconSearch", ""], ["suffixIconX", ""], [1, "b2c-selection-full-content"], [4, "ngIf"], ["class", "w-100 shadow-sm", 4, "ngIf"], [1, "clear-button", "text-link", 3, "click"], ["nz-icon", "", "nzType", "search"], ["nz-icon", "", "nzType", "close", "nzTheme", "outline", 1, "input-clear", 3, "click"], ["class", "b2c-selection-full-checkbox m-0 w-100", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "b2c-selection-full-checkbox", "m-0", "w-100"], [1, "checkbox-label", "text-left", "pl-2"], ["nz-checkbox", "", 1, "float-right", "checkbox", 3, "ngModel", "ngModelChange"], [1, "d-flex", "justify-content-between", "align-items-center"], [1, "checkbox-label", "text-left", "px-2", "pr-3"], [1, "w-100", 3, "ngModel", "ngModelChange"], [1, "b2c-selection-full-radio"], [1, "radio-label", "text-left", "pl-2", "pr-3"], ["nz-radio", "", 1, "float-right", "radio", 3, "nzValue"], [1, "w-100", "shadow-sm"], [1, "filter-button", 3, "oneButton", "click"]], template: function B2CSelectionFullComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nz-drawer", 0);
        ɵngcc0.ɵɵlistener("nzOnClose", function B2CSelectionFullComponent_Template_nz_drawer_nzOnClose_0_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "i", 6);
        ɵngcc0.ɵɵlistener("click", function B2CSelectionFullComponent_Template_i_click_6_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 7);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵtemplate(10, B2CSelectionFullComponent_a_10_Template, 3, 3, "a", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 10);
        ɵngcc0.ɵɵelementStart(12, "form", 11);
        ɵngcc0.ɵɵelementStart(13, "nz-input-group", 12);
        ɵngcc0.ɵɵelementStart(14, "input", 13);
        ɵngcc0.ɵɵlistener("ngModelChange", function B2CSelectionFullComponent_Template_input_ngModelChange_14_listener($event) { return ctx.searchText = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(15, B2CSelectionFullComponent_ng_template_15_Template, 1, 0, "ng-template", null, 14, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(17, B2CSelectionFullComponent_ng_template_17_Template, 1, 0, "ng-template", null, 15, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 16);
        ɵngcc0.ɵɵtemplate(20, B2CSelectionFullComponent_ng_container_20_Template, 4, 5, "ng-container", 17);
        ɵngcc0.ɵɵtemplate(21, B2CSelectionFullComponent_ng_container_21_Template, 4, 5, "ng-container", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(22, B2CSelectionFullComponent_div_22_Template, 2, 1, "div", 18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(16);
        const _r3 = ɵngcc0.ɵɵreference(18);
        ɵngcc0.ɵɵproperty("nzClosable", false)("nzVisible", ctx.visible)("nzBodyStyle", ɵngcc0.ɵɵpureFunction0(12, _c0));
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "checkbox");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("nzPrefix", _r1)("nzSuffix", _r3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.searchText);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "checkbox");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "radio");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "checkbox");
    } }, directives: [ɵngcc2.NzDrawerComponent, ɵngcc3.NzRowDirective, ɵngcc3.NzColDirective, ɵngcc4.NzIconDirective, ɵngcc1.NgIf, ɵngcc5.ɵangular_packages_forms_forms_y, ɵngcc5.NgControlStatusGroup, ɵngcc5.FormGroupDirective, ɵngcc6.NzInputGroupComponent, ɵngcc5.DefaultValueAccessor, ɵngcc6.NzInputDirective, ɵngcc5.NgControlStatus, ɵngcc5.FormControlName, ɵngcc1.NgForOf, ɵngcc7.NzCheckboxComponent, ɵngcc5.NgModel, ɵngcc8.NzRadioGroupComponent, ɵngcc8.NzRadioComponent, ɵngcc9.B2CProductBarFilterComponent], pipes: [ɵngcc10.B2CI18nPipe, ɵngcc11.ɵa], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
B2CSelectionFullComponent.ctorParameters = () => [];
B2CSelectionFullComponent.propDecorators = {
    radioValue: [{ type: Input }],
    type: [{ type: Input }],
    title: [{ type: Input }],
    showAllSelectionCheckbox: [{ type: Input }],
    visible: [{ type: Input }],
    selections: [{ type: Input }],
    filter: [{ type: Output }],
    closed: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CSelectionFullComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-selection-full',
                template: "<nz-drawer\r\n  [nzClosable]=\"false\"\r\n  [nzVisible]=\"visible\"\r\n  nzPlacement=\"left\"\r\n  (nzOnClose)=\"close()\"\r\n  nzWidth=\"100%\"\r\n  [nzBodyStyle]=\"{ height: '100%', overflow: 'hidden' }\"\r\n  nzWrapClassName=\"b2c-selection-full-wrapper\"\r\n>\r\n\r\n<div class=\"b2c-selection-full-container h-100 w-100 d-flex flex-column\">\r\n      <div class=\"b2c-selection-full-header\">\r\n        <div class=\"border-bottom\">\r\n        <div nz-row class=\"py-2\" nzJustify=\"center\">\r\n            <div nz-col nzSpan=\"5\" >\r\n              <i class=\"b2c-selection-full-close\" (click)=\"close()\" nz-icon nzType=\"close\" nzTheme=\"outline\"></i>\r\n            </div>\r\n            <div nz-col nzSpan=\"14\" class=\"drawer-title font-weight-bold text-center\">{{title}}</div>\r\n            <div nz-col nzSpan=\"5\" class=\" text-right\">\r\n              <a *ngIf=\"type === 'checkbox'\" class=\"clear-button text-link\" (click)=\"clear()\">{{ I18nTransKey?.CLEAR | b2cI18n }}</a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"search-box\">\r\n        <form [formGroup]=\"form\">\r\n          <nz-input-group [nzPrefix]=\"prefixIconSearch\" [nzSuffix]=\"suffixIconX\">\r\n            <input class=\"search-input\" [(ngModel)]=\"searchText\" type=\"text\" nz-input placeholder=\"Search\" formControlName=\"search\" />\r\n          </nz-input-group>\r\n          <ng-template #prefixIconSearch>\r\n            <i nz-icon nzType=\"search\"></i>\r\n          </ng-template>\r\n          <ng-template #suffixIconX>\r\n            <i class=\"input-clear\" (click)=\"clearInput()\" nz-icon nzType=\"close\" nzTheme=\"outline\"></i>\r\n              </ng-template>\r\n        </form>\r\n      </div>\r\n      </div>\r\n\r\n\r\n  <div class=\"b2c-selection-full-content\">\r\n    <ng-container *ngIf=\"type === 'checkbox'\">\r\n      <label class=\"b2c-selection-full-checkbox m-0 w-100\" *ngIf=\"showAllSelectionCheckbox\">\r\n        <span class=\"checkbox-label text-left pl-2\">ALL</span>\r\n        <label class=\"float-right checkbox\" nz-checkbox (ngModelChange)=\"onCheckAll($event)\" [(ngModel)]=\"checkAll\"></label>\r\n      </label>\r\n      <ng-container *ngFor=\"let item of selections | filter: searchText;let i = index;\">\r\n\r\n        <label class=\"b2c-selection-full-checkbox option-{{i+1}} m-0 w-100\">\r\n          <div class=\"d-flex justify-content-between align-items-center\">\r\n            <span class=\"checkbox-label text-left px-2 pr-3\">{{item.label}}</span>\r\n            <label class=\"float-right checkbox\" nz-checkbox [(ngModel)]=\"item.checked\"></label>\r\n          </div>\r\n           </label>\r\n       </ng-container>\r\n     </ng-container>\r\n\r\n     <ng-container *ngIf=\"type === 'radio'\">\r\n\r\n      <nz-radio-group (ngModelChange)=\"onModelChange($event)\" [(ngModel)]=\"radioValue\" class=\"w-100\" >\r\n        <ng-container *ngFor=\"let item of selections | filter: searchText;let i = index;\">\r\n          <label class=\"b2c-selection-full-radio\">\r\n            <div class=\"d-flex justify-content-between align-items-center\">\r\n              <span class=\"radio-label text-left pl-2 pr-3\">{{ item.label }}</span>\r\n              <label nz-radio [nzValue]=\"item.value\" class=\"float-right radio\"></label>\r\n            </div>\r\n          </label>\r\n        </ng-container>\r\n      </nz-radio-group>\r\n  </ng-container>\r\n  </div>\r\n\r\n\r\n      <div class=\"w-100 shadow-sm\" *ngIf=\"type === 'checkbox'\" >\r\n        <b2c-product-bar-filter class=\"filter-button\" [oneButton]=\"'true'\" (click)=\"filterItem()\"></b2c-product-bar-filter>\r\n      </div>\r\n    </div>\r\n    </nz-drawer>\r\n\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { selections: [{
            type: Input
        }], filter: [{
            type: Output
        }], closed: [{
            type: Output
        }], visible: [{
            type: Input
        }], radioValue: [{
            type: Input
        }], type: [{
            type: Input
        }], title: [{
            type: Input
        }], showAllSelectionCheckbox: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    B2CSelectionFullComponent.prototype.form;
    /**
     * @type {?}
     * @private
     */
    B2CSelectionFullComponent.prototype._visible;
    /**
     * @type {?}
     * @private
     */
    B2CSelectionFullComponent.prototype.subscription;
    /** @type {?} */
    B2CSelectionFullComponent.prototype.searchText;
    /** @type {?} */
    B2CSelectionFullComponent.prototype.I18nTransKey;
    /** @type {?} */
    B2CSelectionFullComponent.prototype.checkAll;
    /** @type {?} */
    B2CSelectionFullComponent.prototype.radioValue;
    /** @type {?} */
    B2CSelectionFullComponent.prototype.type;
    /**
     * Set Title
     * @type {?}
     */
    B2CSelectionFullComponent.prototype.title;
    /** @type {?} */
    B2CSelectionFullComponent.prototype.showAllSelectionCheckbox;
    /**
     * Set Selections Data
     * @type {?}
     */
    B2CSelectionFullComponent.prototype.selections;
    /**
     * Filter Event
     * @type {?}
     */
    B2CSelectionFullComponent.prototype.filter;
    /**
     * Closed Event
     * @type {?}
     */
    B2CSelectionFullComponent.prototype.closed;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-selection-half.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * ##### Import this component individually to your module
 * `import { B2CSelectionHalfModule } from 'b2c-ui/product-ranking';`
 */
class B2CSelectionHalfComponent {
    constructor() {
        this.I18nTransKey = I18nTransKey;
        /**
         * Set Selection Half Items
         */
        this.itemList = [];
        /**
         * Set Radiogroup Value
         */
        this.radioValue = '';
        /**
         * Filter Button Event
         */
        this.filter = new EventEmitter();
    }
    /**
     * @ignore
     * @return {?}
     */
    filterItem() {
        if (this.type === 'radio') {
            this.filter.emit(this.radioValue);
        }
        else {
            /** @type {?} */
            const result = [];
            this.itemList.forEach((/**
             * @param {?} item
             * @return {?}
             */
            (item) => {
                if (item.checked) {
                    result.push(item.value);
                }
            }));
            this.filter.emit(result);
        }
    }
    /**
     * @param {?} check
     * @return {?}
     */
    onCheckAll(check) {
        this.checkAll = check;
        if (this.checkAll) {
            this.itemList.forEach((/**
             * @param {?} selection
             * @return {?}
             */
            (selection) => {
                selection.checked = true;
            }));
        }
        else {
            this.itemList.forEach((/**
             * @param {?} selection
             * @return {?}
             */
            (selection) => {
                selection.checked = false;
            }));
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    onModelChange(value) {
        this.radioValue = value;
        _log(this.radioValue);
        this.filterItem();
    }
    /**
     * @ignore
     * @return {?}
     */
    clear() {
        if (this.type === 'radio') {
            this.radioValue = undefined;
            return;
        }
        this.itemList.forEach((/**
         * @param {?} item
         * @return {?}
         */
        (item) => item.checked = false));
    }
}
B2CSelectionHalfComponent.ɵfac = function B2CSelectionHalfComponent_Factory(t) { return new (t || B2CSelectionHalfComponent)(); };
B2CSelectionHalfComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CSelectionHalfComponent, selectors: [["b2c-selection-half"]], inputs: { itemList: "itemList", radioValue: "radioValue", title: "title", type: "type" }, outputs: { filter: "filter" }, decls: 8, vars: 5, consts: [[1, "b2c-selection-half", "position-relative"], [1, "mb-2"], [1, "b2c-selection-half-title"], ["class", "float-right text-link", 3, "click", 4, "ngIf"], [4, "ngIf"], ["class", "rounded-0", "class", "w-100", 4, "ngIf"], [1, "float-right", "text-link", 3, "click"], [1, "b2c-selection-half-item", "border-bottom", "py-3"], ["nz-checkbox", "", 1, "float-right", 3, "ngModel", "ngModelChange"], [4, "ngFor", "ngForOf"], [1, "d-flex", "justify-content-between", "align-items-center"], [3, "ngModel", "ngModelChange"], ["nz-radio", "", 1, "float-right", 3, "nzValue"], [1, "w-100"], ["nz-button", "", "nzBlock", "", "nzType", "primary", 1, "_filter_", 3, "click"]], template: function B2CSelectionHalfComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, B2CSelectionHalfComponent_a_4_Template, 3, 3, "a", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, B2CSelectionHalfComponent_ng_container_5_Template, 6, 2, "ng-container", 4);
        ɵngcc0.ɵɵtemplate(6, B2CSelectionHalfComponent_ng_container_6_Template, 3, 2, "ng-container", 4);
        ɵngcc0.ɵɵtemplate(7, B2CSelectionHalfComponent_nz_card_7_Template, 4, 3, "nz-card", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "checkbox");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type == "checkbox");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type == "radio");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "checkbox");
    } }, directives: [ɵngcc1.NgIf, ɵngcc7.NzCheckboxComponent, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc1.NgForOf, ɵngcc8.NzRadioGroupComponent, ɵngcc8.NzRadioComponent, ɵngcc12.NzCardComponent, ɵngcc13.NzButtonComponent], pipes: [ɵngcc10.B2CI18nPipe], encapsulation: 2, changeDetection: 0 });
B2CSelectionHalfComponent.propDecorators = {
    title: [{ type: Input }],
    type: [{ type: Input }],
    itemList: [{ type: Input }],
    radioValue: [{ type: Input }],
    filter: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CSelectionHalfComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-selection-half',
                template: "<div class=\"b2c-selection-half position-relative\">\r\n    <div class=\"mb-2\">\r\n      <span class=\"b2c-selection-half-title\">{{ title }}</span>\r\n      <a class=\"float-right text-link\" *ngIf=\"type === 'checkbox'\" (click)=\"clear()\">{{ I18nTransKey?.CLEAR | b2cI18n }}</a>\r\n    </div>\r\n    <ng-container *ngIf=\"type == 'checkbox'\">\r\n      <label class=\"b2c-selection-half-item border-bottom py-3\">\r\n        <span>ALL</span>\r\n        <label class=\"float-right\" nz-checkbox (ngModelChange)=\"onCheckAll($event)\" [(ngModel)]=\"checkAll\"></label>\r\n      </label>\r\n      <ng-container *ngFor=\"let item of itemList\">\r\n        <label class=\"b2c-selection-half-item border-bottom py-3\">\r\n          <div class=\"d-flex justify-content-between align-items-center\">\r\n            <span>{{ item.label }}</span>\r\n            <label nz-checkbox [(ngModel)]=\"item.checked\" class=\"float-right\"></label>\r\n          </div>\r\n        </label>\r\n      </ng-container>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"type == 'radio'\">\r\n      <nz-radio-group (ngModelChange)=\"onModelChange($event)\" [(ngModel)]=\"radioValue\" >\r\n        <ng-container *ngFor=\"let item of itemList\">\r\n          <label class=\"b2c-selection-half-item border-bottom py-3\">\r\n            <div class=\"d-flex justify-content-between align-items-center\">\r\n              <span>{{ item.label }}</span>\r\n              <label nz-radio [nzValue]=\"item.value\" class=\"float-right\"></label>\r\n            </div>\r\n          </label>\r\n        </ng-container>\r\n      </nz-radio-group>\r\n    </ng-container>\r\n  <nz-card class=\"rounded-0\" class=\"w-100\" *ngIf=\"type === 'checkbox'\">\r\n    <button nz-button nzBlock (click)=\"filterItem()\" nzType=\"primary\" class=\"_filter_\">{{ I18nTransKey?.FILTER | b2cI18n }}</button>\r\n  </nz-card>\r\n</div>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { itemList: [{
            type: Input
        }], radioValue: [{
            type: Input
        }], filter: [{
            type: Output
        }], title: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    B2CSelectionHalfComponent.prototype.I18nTransKey;
    /** @type {?} */
    B2CSelectionHalfComponent.prototype.checkAll;
    /**
     * Set Selection Half Title
     * @type {?}
     */
    B2CSelectionHalfComponent.prototype.title;
    /**
     * Set Selection Half Type
     * @type {?}
     */
    B2CSelectionHalfComponent.prototype.type;
    /**
     * Set Selection Half Items
     * @type {?}
     */
    B2CSelectionHalfComponent.prototype.itemList;
    /**
     * Set Radiogroup Value
     * @type {?}
     */
    B2CSelectionHalfComponent.prototype.radioValue;
    /**
     * Filter Button Event
     * @type {?}
     */
    B2CSelectionHalfComponent.prototype.filter;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-menu-drawer.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CMenuDrawerModule {
}
B2CMenuDrawerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CMenuDrawerModule });
B2CMenuDrawerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CMenuDrawerModule_Factory(t) { return new (t || B2CMenuDrawerModule)(); }, imports: [[
            CommonModule,
            NzRadioModule,
            NzCheckboxModule,
            NzGridModule,
            NzButtonModule,
            NzCardModule,
            FormsModule,
            I18nModule,
            NzDrawerModule,
            NzInputModule,
            NzFormModule,
            B2CProductBarModule,
            ReactiveFormsModule,
            B2CSharedPipeModule,
            B2CNgzIconModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CMenuDrawerModule, { declarations: function () { return [B2CMenuDrawerComponent,
        B2CSelectionHalfComponent,
        B2CSelectionFullComponent]; }, imports: function () { return [CommonModule,
        NzRadioModule,
        NzCheckboxModule,
        NzGridModule,
        NzButtonModule,
        NzCardModule,
        FormsModule,
        I18nModule,
        NzDrawerModule,
        NzInputModule,
        NzFormModule,
        B2CProductBarModule,
        ReactiveFormsModule,
        B2CSharedPipeModule,
        B2CNgzIconModule]; }, exports: function () { return [B2CMenuDrawerComponent,
        B2CSelectionFullComponent,
        B2CSelectionHalfComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CMenuDrawerModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CMenuDrawerComponent, B2CSelectionHalfComponent, B2CSelectionFullComponent],
                exports: [B2CMenuDrawerComponent, B2CSelectionFullComponent, B2CSelectionHalfComponent],
                imports: [
                    CommonModule,
                    NzRadioModule,
                    NzCheckboxModule,
                    NzGridModule,
                    NzButtonModule,
                    NzCardModule,
                    FormsModule,
                    I18nModule,
                    NzDrawerModule,
                    NzInputModule,
                    NzFormModule,
                    B2CProductBarModule,
                    ReactiveFormsModule,
                    B2CSharedPipeModule,
                    B2CNgzIconModule
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-menu-drawer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CMenuDrawerComponent, B2CMenuDrawerModule, B2CSelectionFullComponent, B2CSelectionHalfComponent };


//# sourceMappingURL=b2c-ui-menu-drawer.js.map